/*
 * @Author: your name
 * @Date: 2021-05-05 10:20:25
 * @LastEditTime: 2021-05-05 10:45:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dc-wsy-pet-raise-plan-front\store\index,.js
 */

 import Vue from 'vue'
 import dataEntity from './store.js'
 Vue.use(dataEntity)
 const store = new dataEntity.Store()
 export default store
